import { LocationDetails, LocationSuggestion } from '@griply/types';

const joinLabelParts = (first: string, second: string) =>
  [first, second].filter(Boolean).join(', ');

export const formatLocationSuggestionLabel = (
  suggestion: LocationSuggestion,
): string => joinLabelParts(suggestion.mainText, suggestion.secondaryText);

export const formatLocationDetailsLabel = (
  details: LocationDetails,
): string | null =>
  joinLabelParts(details.name, details.formattedAddress) || null;
